import ActionTypeServicio from "../ActionTypeServicio";

export default class ActualizarServicio extends ActionTypeServicio {
    ejecutar(estado, nuevoEstado) {
        nuevoEstado.flag.procesandoComando = true;
        /* nuevoEstado.flag.sensorDeAccionActualizar = !(estado.flag.sensorDeAccionActualizar); */
        return nuevoEstado;
    }
}
